import { Controller } from '@hotwired/stimulus';
import { MaskInput } from 'maska';

export default class extends Controller {
  connect() {
    new MaskInput(this.element.querySelectorAll('[data-maska]'));
    this.initializeValidation();
  }
 
  initializeValidation() {
    const form = this.element;
    if (form) {
      form.addEventListener("submit", function (event) {
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
        }
        form.classList.add("was-validated");
      }, false);
    }
  }
}
